import { render, staticRenderFns } from "./iva-compras.vue?vue&type=template&id=ac48ed7a&scoped=true"
import script from "./iva-compras.vue?vue&type=script&lang=js"
export * from "./iva-compras.vue?vue&type=script&lang=js"
import style0 from "./iva-compras.vue?vue&type=style&index=0&id=ac48ed7a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac48ed7a",
  null
  
)

export default component.exports